"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Copy = void 0;
var react_1 = __importStar(require("react"));
var storybook_1 = require("@eyecons/storybook");
var Copy = function (_a) {
    var id = _a.id, placeholder = _a.placeholder, value = _a.value, onClick = _a.onClick, label = _a.label, _b = _a.type, type = _b === void 0 ? 'input' : _b;
    var textArea = react_1.useRef();
    var copy = function () {
        storybook_1.Helpers.copy(value);
    };
    react_1.useEffect(function () {
        var element = textArea.current;
        if (element) {
            textArea.current.style.height = (element.scrollHeight > element.clientHeight) ? (element.scrollHeight) + 'px' : '60px';
        }
    }, []);
    return react_1.default.createElement("div", { className: 'storybook-buttons-copy' },
        type === 'input' && react_1.default.createElement("input", { id: id, value: value, placeholder: placeholder, disabled: true }),
        type === 'textarea' &&
            react_1.default.createElement("textarea", { ref: textArea, id: id, placeholder: placeholder, value: value, disabled: true }),
        react_1.default.createElement(storybook_1.Buttons.Button, { disabled: !value, onClick: onClick || copy }, label));
};
exports.Copy = Copy;
